var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"rotate":360,"size":100,"width":15,"value":_vm.value,"color":_vm.myColor}},[_vm._v("\n    "+_vm._s(_vm.value)+"%\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }